import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { FeedbackService } from '../../_service/feedback.service';
import { ActivatedRoute, Router  } from '@angular/router';
@Component({
  selector: 'app-add-edit-opd-feedback',
  templateUrl: './add-edit-opd-feedback.component.html',
  styleUrls: ['./add-edit-opd-feedback.component.css']
})
export class AddEditOpdFeedbackComponent implements OnInit {
  feedbackForm: FormGroup;submitted:boolean=false;OPDId: any = '';loading:boolean=false;myrole:string;FeedbackId: any = '';image_url:any='';after_image_url:any='';video_url:any='';fileDeletingLoader:boolean=false;s3url='';

  placements = ['left'];
  popoverTitle = 'Are you sure?';
  popoverMessage = 'Are you really <b>sure</b> you want to do this?';
  confirmText = 'Yes <i class="fas fa-check"></i>';
  cancelText = 'No <i class="fas fa-times"></i>';
  confirmClicked = false;
  cancelClicked = false;fileDeleting:boolean = false;

  constructor(private formBuilder: FormBuilder,private leadapi:LeadsService,private sharedapi:SharedService,private feedbackapi:FeedbackService,private router:Router,private activatedRoute: ActivatedRoute) { 
    this.feedbackForm = this.formBuilder.group({ 
      'pname' : [null],
      'treatment' : [null],
      'docname' : [null],
      'hospitalname' : [null],
      'bd_name' : [null],
      'medical_counseller_rating' : [null],
      'hospital_service_rating' : [null],
      'hospital_cleanliness_rating' : [null],
      'doctor_treatment_rating' : [null],
      'experience_with_glamyo_rating' : [null],
      'overallrating' : [null],
      'followupdate' : [null, Validators.required],
      'feedbackstatus' : [null, Validators.required],
      'recodinglink' : [null],
      'description' : [null],
      'media': [null],
      'after_media': [null],
      'video_media': [null],
      'number_of_views': [null],
      'video_image_title': [null],
      'media_approval_status': [null],
    });
    this.activatedRoute.params.subscribe(params => {
      if (params['opd_id']) {
          this.OPDId = params['opd_id'];
          this.patchPatientData();
          this.patchFeedbackData();
          // if(params['feedback_id']){
          //   this.FeedbackId= params['feedback_id'];
          //   this.patchFeedbackData();
          // }
      }

    });

  }

  setRatingValue(value,formkey){
    this.feedbackForm.controls[formkey].setValue(value);
  }

  ngOnInit(): void {
    this.myrole = localStorage.getItem('role');
    this.s3url = localStorage.getItem('s3url');
  }

  async patchPatientData(){
    this.leadapi.viewOpdDetails(this.OPDId).subscribe((response:any) => {
      if(response.status){
          this.feedbackForm.patchValue({
            'pname':response.data.patient,  
            'treatment':response.data.treatment_name,  
            'docname':response.data.doctor_name,  
            'hospitalname':response.data.hospital_name,
            'bd_name':response.data.bd_name
          })
      }
    }, error => {
        this.sharedapi.checkError(error);
    });

  }

  async patchFeedbackData(){
    let OpdId = {
      "opd_id": this.OPDId,
      
    }
    await this.feedbackapi.getOpdfeedbackDetails(OpdId).subscribe((response:any) => {
      if(response.status){
          this.feedbackForm.patchValue({
            'medical_counseller_rating':response.data.medical_counseller_rating,  
            'hospital_service_rating':response.data.hospital_service_rating,  
            'hospital_cleanliness_rating':response.data.hospital_cleanliness_rating,  
            'doctor_treatment_rating':response.data.doctor_treatment_rating,
            'experience_with_glamyo_rating':response.data.experience_with_glamyo_rating,
            'overallrating':response.data.overall_rating,
            'followupdate':new Date(response.data.followup_date * 1000),
            'feedbackstatus':response.data.status,
            'recodinglink':response.data.recording_link,
            'description':response.data.description ,
            'number_of_views':response.data.number_of_views,
            'video_image_title':response.data.video_image_title,
            'media_approval_status':response.data.media_approval_status,
            'image_link':response.data.image_link,
            'after_surgery_image_link':response.data.after_surgery_image_link,
            'video_link':response.data.video_link
          })
          this.image_url = response.data.image_link;
          this.after_image_url = response.data.after_surgery_image_link;
          this.video_url = response.data.video_link;
      }
    }, error => {
        this.sharedapi.checkError(error);
    });

  }

  get f() { return this.feedbackForm.controls; }

  async addFeedback(){
    this.submitted = true;
    this.loading = true;
     // stop here if form is invalid
      if (this.feedbackForm.invalid) {
        this.loading = false;
        return;
      }
      this.feedbackForm.value.opd_id= parseInt(this.OPDId); 
        await this.feedbackapi.addOpdFeedback(this.feedbackForm.value)
        .subscribe((data:any) => {
           this.submitted = false;
           this.loading = false;
           if(data.status)
           {
               this.sharedapi.presentToast('Feedback Added Successfully');
               this.router.navigateByUrl('/opds');
           }
           else
           {
               this.sharedapi.presentToast(data.msg);
           }
         }, error => 
           {
               this.sharedapi.checkError(error);
        });
     
  }    

  selectMedia(event)
  {
    const file = (event.target as HTMLInputElement).files[0];
    this.feedbackForm.patchValue({
      media: file
    });
  }
  selectAfterMedia(event)
  {
    const file = (event.target as HTMLInputElement).files[0];
    this.feedbackForm.patchValue({
      after_media: file
    });
  }

  selectVideoMedia(event)
  {
    const file = (event.target as HTMLInputElement).files[0];
    this.feedbackForm.patchValue({
      video_media: file
    });
  }

  removeFile(file_type)
  {
    this.fileDeletingLoader = true;
    this.feedbackapi.deleteOpdfeedback_files(this.OPDId, file_type).subscribe((data:any) => {
      this.fileDeletingLoader = false;
      if(data.status)
      {
        if(file_type == 'video_link')
        {
          this.video_url = '';
        }
        if(file_type == 'image_link')
        {
          this.image_url = '';
        }
      }
      this.sharedapi.presentToast(data.msg);
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

}
